import { SearchIcon } from 'icons/search-icon';
import { X } from 'lucide-react';
import React, { RefObject } from 'react';
import { useIntl } from 'react-intl';

import { SearchPopover } from '../v2/search-popover/index';

interface JobSearchInputProps {
  jobSearch: string;
  setJobSearch: (value: string) => void;
  openJobPopover: boolean;
  setOpenJobPopover: React.Dispatch<React.SetStateAction<boolean>>;
  jobInputRef: RefObject<HTMLInputElement>;
  onClear: () => void;
  onKeyDown?: (e: React.KeyboardEvent<HTMLInputElement>) => void;
  onJobSelect?: (value: string) => void;
  scrollToJobs: () => void;
}

export function JobSearchInput({
  jobSearch,
  setJobSearch,
  openJobPopover,
  setOpenJobPopover,
  jobInputRef,
  onClear,
  onKeyDown,
  onJobSelect,
  scrollToJobs,
}: JobSearchInputProps) {
  const intl = useIntl();

  return (
    <div
      className={`xs:max-w-[311px] relative w-full lg:w-[311px] lg:max-w-none lg:flex-none ${
        openJobPopover ? 'z-40' : 'z-30'
      }`}
    >
      <div className="flex h-12 w-full items-center gap-3 border bg-white px-4 py-3">
        <SearchIcon className="text-gray-400" />
        <input
          ref={jobInputRef}
          placeholder={intl.formatMessage({
            defaultMessage: 'Search by job title or keyword',
            description: 'Placeholder for job search input',
          })}
          onChange={e => {
            setJobSearch(e.target.value);
            setOpenJobPopover(e.target.value.length > 0);
          }}
          onClick={() => {
            setOpenJobPopover(true);
          }}
          onFocus={() => {
            setOpenJobPopover(true);
          }}
          onKeyDown={onKeyDown}
          className="flex-1 border-none outline-none"
          value={jobSearch}
        />
        {jobSearch && (
          <button
            type="button"
            onClick={onClear}
            className="flex h-5 w-5 items-center justify-center rounded-full bg-gray-200 text-gray-500 hover:bg-gray-300 hover:text-gray-700"
          >
            <X className="h-3 w-3" />
          </button>
        )}
      </div>
      {openJobPopover && (
        <SearchPopover
          searchString={jobSearch}
          setOpenPopover={setOpenJobPopover}
          scrollToJobs={scrollToJobs}
          setInputText={setJobSearch}
          filterTypes={['jobs']}
          showSectionHeaders={false}
          onJobSelect={onJobSelect}
          ignoreClickOutsideElements={[jobInputRef]}
        />
      )}
    </div>
  );
}
